import { CloseCircleFilled } from '@ant-design/icons'
import { ChatFileItem } from './doc'
import AudioFileSvg from '@/assets/images/file/file-audio.svg'
import VideoFileSvg from '@/assets/images/file/file-video.svg'
import CommonFileSvg from '@/assets/images/file/file-common.svg'
import { LoaderCircle } from 'lucide-react'

const fileIconMap = {
  audio: AudioFileSvg,
  video: VideoFileSvg,
  common: CommonFileSvg,
}

const FileItem = ({ file, onClose }: any) => {
  // console.log('file =>', file)
  if (file.serverType === 'pic') {
    return (
      <div className="flex">
        <div className="relative w-[60px] h-[60px] cursor-pointer rounded-md">
          <img
            className={`${
              !file.serverUrl && 'blur-sm animate-pulse'
            } object-cover w-full h-full rounded-md`}
            loading="lazy"
            src={file.serverUrl}
          />
          {file.serverUrl && (
            <CloseCircleFilled
              className="cursor-pointer text-base absolute -top-1.5 -right-1.5 bg-white rounded-full"
              onClick={e => {
                e.stopPropagation()
                onClose?.()
              }}
            />
          )}
        </div>
      </div>
    )
  }

  if (file.serverType === 'doc') {
    return (
      <div className="relative">
        <ChatFileItem
          doc={{
            filename: file.name,
            filesize: file.size,
            fileurl: file.serverUrl,
          }}
        />
        {file.serverUrl && (
          <CloseCircleFilled
            className="cursor-pointer text-base absolute -top-1.5 -right-1.5"
            onClick={e => {
              e.stopPropagation()
              onClose?.()
            }}
          />
        )}
      </div>
    )
  }

  return (
    <div className="relative flex w-60 rounded-xl p-2 bg-gradient-to-b from-[#FFFFFF] to-[#EEF7FF] border border-[#1C1F230F]">
      <div className="w-full flex items-center gap-2">
        <img
          className="w-[60px] h-[60px] flex-shrink-0"
          src={
            fileIconMap[file.serverType as keyof typeof fileIconMap] ||
            fileIconMap.common
          }
        />
        <div className="min-w-0 flex-1 py-2 flex flex-col pr-2">
          <div className="text-ellipsis overflow-hidden text-nowrap w-full">
            {file.name}
          </div>
          {file.serverUrl ? (
            <span className="text-xs flex gap-2 text-[#6D728D]">
              <span>{file.extension}</span>
              <span>{file.showSize}</span>
            </span>
          ) : (
            <span className="text-xs flex items-center gap-2 text-[#6D728D]">
              <LoaderCircle size={14} className="animate-spin mr-1" />
              <span>上传中...</span>
            </span>
          )}
        </div>
      </div>
      {file.serverUrl && (
        <CloseCircleFilled
          className="cursor-pointer text-base absolute -top-1.5 -right-1.5"
          onClick={e => {
            e.stopPropagation()
            onClose?.()
          }}
        />
      )}
    </div>
  )
}

export default FileItem
